import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type { IbhCustomArticleLifetimeParams } from '@igus/iglidur-bearing-hub-api';
import * as Sentry from '@sentry/nextjs';

export const fetchCustomArticleLifeTime = async (
  ibhCustomArticleLifetimeParams: IbhCustomArticleLifetimeParams
): Promise<number> => {
  try {
    const response = await ibhApiService.customArticleLifetime(ibhCustomArticleLifetimeParams);
    return response.data.lifetime;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(`Cannot fetch lifetime for custom article number: ${ibhCustomArticleLifetimeParams.articleNumber}`);
  }
};
